
import { Injectable } from "@angular/core";
import { CommonService } from "src/app/services/common/common.service";
import { Firestore, doc, getDoc } from "@angular/fire/firestore";
import { MatDialog } from "@angular/material/dialog";
import { filter, switchMap, take, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { Data } from "@angular/router";
import { AddCardComponent } from "../add-card.component";
import { CheckoutConfirmationComponent } from "src/app/components/checkout-confirmation/checkout-confirmation.component";
import { ExitIntentPopup } from "src/app/components/exit-intent-popup/exit-intent-popup";


@Injectable({
    providedIn: null,
})
export class ExitIntentService {
  private pwaSegmentStatus: string;
  private destroy$ = new Subject<void>();
  private exit_offer_id: number;
  private capping_status = false;
  private isOneOff = false;
  private offerId: number;
  private unsubscribe$ = new Subject<void>();

  constructor(
    private commonService: CommonService,
    private firestore: Firestore,
    private matDialog: MatDialog,
    ) {}


  loadSegmentData() {
      this.commonService.getUid("PwasegementData")
        .pipe(
          take(1),
          switchMap(async (uid: string) => {
            if (!uid) {
              return null;
            }
            const userDocPath = `users/${uid}`;
            try {
              const userSnap = await getDoc(doc(this.firestore, userDocPath));
              if (!userSnap.exists()) {
                return null;
              }
              const userData = userSnap.data();
              this.pwaSegmentStatus = userData?.['pwa_segment_status'];
              return uid;
            } catch (err) {
              return null;
            }
          })
        )
        .subscribe({
          next: (uid) => {
            if (!uid) return;
  
            this.commonService.slide$
              .pipe(
                filter((slide: Data): slide is Data => !!slide),
                take(1),
                takeUntil(this.destroy$)
              )
              .subscribe(async (slide) => {
                this.isOneOff = slide?.isOneOff ?? false;
                this.offerId = slide?.slide_info?.offer_id;
                this.exit_offer_id = slide?.exit_offer_id;
                const offerCappingPath = `users/${uid}/offer_capping/${this.exit_offer_id}`;
  
                const snap = await getDoc(doc(this.firestore, offerCappingPath));
                if (snap.exists()) {
                  const data = snap.data();
                  this.capping_status = data?.capping_status ?? false;
                }
              });
          },
  
          error: (err) => {
            return err;
          }
        });
  }
    handleExitIntent(
        component: AddCardComponent
      ) {
        // Keep existing popup rules; only ensure exit_offer_id is current from slide.
        // Assign directly (no ?? fallback) so a prior slide's exit_offer_id cannot stick.
        const slide = this.commonService.getSlideData();
        if (slide) {
          this.isOneOff = slide?.isOneOff ?? false;
          this.offerId = slide?.slide_info?.offer_id;
          this.exit_offer_id = slide?.exit_offer_id;
        }

        const paymentParam = component.actRoute.snapshot.queryParamMap.get('payment')

        if (
          paymentParam || component.purchaseDetail$.value?.page === 'store' || component.data?.isStoreOffer || this.isOneOff
        ) {
          this.openConfirmationPopup(component);
          return;
        }

        // No exit_offer_id in slide/FB → confirmation (avoid ExitIntent with blank £).
        if (this.pwaSegmentStatus === 'subscriber' || this.capping_status || !this.exit_offer_id) {
          this.openConfirmationPopup(component);
        } else {
          this.openExitIntentPopup(component, this.exit_offer_id);
        }
      }

    openConfirmationPopup(componentContext: AddCardComponent) {
        const confirmationDialog = this.matDialog.open(CheckoutConfirmationComponent, {
          panelClass: "mysterybox-dialog-size",
          backdropClass: "mysterybox-back-drop-color",
          hasBackdrop: true,
          disableClose: false,
        });
    
        confirmationDialog
          .afterClosed()
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe({
            next: (response: boolean) => {
              if (response) {
                componentContext.goBack();
              }
            },
            error: (error) => {
              return error;
            },
          });
      }

      openExitIntentPopup(componentContext: AddCardComponent, offerid: number) {
          const queryParams = componentContext.actRoute.snapshot.queryParams || {};
          const confirmationDialog = this.matDialog.open(ExitIntentPopup, {
            panelClass: "mysterybox-dialog-size",
            backdropClass: "mysterybox-back-drop-color",
            hasBackdrop: true,
            disableClose: false,
            data: { offerId: offerid, ...queryParams }
          });
      
          confirmationDialog
            .afterClosed()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
              next: (response: boolean) => {
                if (response) {
                  componentContext.goBack();
                }
              },
              error: (error) => {
                return error;
              },
            });
        }

}